<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="less">
@import '../scss/vendors/iview/custom';
@import '~iview/src/styles/mixins/index';
@import '~iview/src/styles/common/index';
@import '~iview/src/styles/animation/index';
@import '~iview/src/styles/components/index';
</style>

<style lang="scss">
@import '../scss/vendors/fontawesome/scss/fontawesome';
@import '../scss/vendors/fontawesome/scss/solid';
@import '../scss/vendors/fontawesome/scss/brands';
@import '../scss/vendors/fontawesome/scss/regular';
@import '../scss/vendors/fontawesome/scss/light';

/* Import Bootstrap Vue Styles */
@import '~bootstrap-vue/dist/bootstrap-vue.css';
// Import Main styles for this application
@import './scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue